import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no-overview-data",
  "use": "icon-no-overview-data-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-no-overview-data\">\n<rect width=\"48\" height=\"48\" rx=\"24\" fill=\"#F2F3F5\" />\n<rect x=\"14\" y=\"23\" width=\"5\" height=\"10\" rx=\"2\" fill=\"#A9AEB8\" />\n<rect x=\"21\" y=\"15\" width=\"5\" height=\"18\" rx=\"2\" fill=\"#A9AEB8\" />\n<rect x=\"28\" y=\"19\" width=\"5\" height=\"14\" rx=\"2\" fill=\"#A9AEB8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/no-overview-data.svg
// module id = +lt3
// module chunks = 258